import { http } from '@/lib/public-http';
import * as Sentry from '@sentry/react';

export const axiosPublicBaseQuery =
  () =>
  async ({ url, method = 'get', params = null, data = null }) => {
    try {
      const config = {};
      if (method === 'get') {
        config.url = url;
        config.method = 'get';
        config.params = params;
      } else if (
        method === 'post' ||
        method === 'put' ||
        method === 'delete' ||
        method === 'patch'
      ) {
        config.url = url;
        config.method = method;
        config.params = params;
        config.data = data;
      }
      const result = await http(config);

      if (
        result?.errors?.length > 0 ||
        (result?.errors && Object.keys(result?.errors) > 0)
      ) {
        return {
          error: result?.errors,
        };
      }
      return {
        data: result?.data,
      };
    } catch (err) {
      Sentry.captureMessage('http-redux-query-error', (scope) => {
        scope.addBreadcrumb({
          data: {
            error: err,
          },
          level: 'info',
        });
      });
      return {
        // A failed request must always produce a truthy error: a 5xx with an
        // empty body left `data` undefined, so callers saw neither data nor
        // error and reported success.
        error: err?.response?.data || {
          status: err?.response?.status,
          message: err?.message || 'Request failed',
        },
      };
    }
  };
